import type { CSSProperties } from 'react';

/**
 * PrivateEventBadge — the small marker that distinguishes a private event
 * wherever it appears alongside public workshops: the regional calendar chip
 * and the teacher's own schedule rows. Never on public sale, so it has to
 * read distinctly at a glance rather than blend in as just another workshop.
 *
 * Its own compact box rather than `.nb-pill`'s fixed `height: 22px` — that
 * height is tuned for a status pill, and inheriting it inflates a calendar
 * week row and overlaps the chip's own text. `nb-warn` on `nb-pill`'s default
 * surface background reads under AA contrast, so this pairs it with
 * `nb-warn-soft` the same way the other warn pills on the page do.
 */
export function PrivateEventBadge({
  fontSize = 9,
  style,
}: {
  fontSize?: number;
  /** Positioning override — the full calendar chip pins this to a corner
   *  rather than sharing the venue-name element. */
  style?: CSSProperties;
}) {
  return (
    <span
      className="nb-pill"
      style={{
        height: 'auto',
        lineHeight: 1,
        padding: '1px 5px',
        fontSize,
        fontWeight: 700,
        color: 'var(--nb-warn)',
        background: 'var(--nb-warn-soft)',
        flexShrink: 0,
        ...style,
      }}
    >
      Private
    </span>
  );
}
